/* eslint-disable global-require */
import admin from './admin';

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '/',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    admin,
    {
      path: '/robot',
      load: () => import(/* webpackChunkName: 'robot' */ './robot'),
    },
    {
      path: '/login',
      load: () => import(/* webpackChunkName: 'login' */ './login'),
    },
    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action(context) {
    const { next, pathname } = context;
    const route = await next();
    const en = pathname.indexOf('/en') !== -1;

    if (en) {
      // route.title = route.titleEn
      //   ? `${route.titleEn} - 政博士 | Professional Chatbot`
      //   : '政博士 | Professional Chatbot';
    } else {
      // route.title = route.title
      //   ? `${route.title} - 政博士 | 电子政务机器人`
      //   : '政博士 | 电子政务机器人';
    }
    route.description = route.description || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;
